import {
  queryElectronicReceipt,
  queryListForPage,
  signElectronicReceipt,
  signCheckReceiptUser,
  queryElectronicReceiptByOrderId,
  querySignElectronicReceipt,
  toSignElectronicReceipt,
  receiptOrderGoods,
  getOrderQyPassed,
  checkUploadOrderVoucher
} from "@/api/order/signature";

export default {
  namespaced: true,
  state: {
    list: []
  },
  actions: {
    async queryElectronicReceipt(context, params) {
      const { data } = await queryElectronicReceipt(params);
      return data;
    },

    async queryListForPage(context, params) {
      const { data } = await queryListForPage(params);
      return data;
    },

    async signElectronicReceipt(context, params) {
      const res = await signElectronicReceipt(params);
      return res;
    },

    async receiptOrderGoods(context, params) {
      const res = await receiptOrderGoods(params);
      return res;
    },

    async getOrderQyPassed(context, params) {
      const res = await getOrderQyPassed(params);
      return res;
    },

    async signCheckReceiptUser(context, params) {
      const res = await signCheckReceiptUser(params);
      return res;
    },

    async queryElectronicReceiptByOrderId(context, params) {
      const { data } = await queryElectronicReceiptByOrderId(params);
      return data;
    },

    async querySignElectronicReceipt(context, params) {
      const { data } = await querySignElectronicReceipt(params);
      return data;
    },

    async toSignElectronicReceipt(context, params) {
      const data = await toSignElectronicReceipt(params);
      return data;
    },

    async checkUploadOrderVoucher(context, params) {
      const res = await checkUploadOrderVoucher(params);
      return res;
    }
  }
};
